import React, { HTMLAttributes, HTMLProps } from 'react';

import { ImmutableGenericNodeEntity } from '../..';
import { CoreLink } from '../../../../components';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';
import useClasses from '../../../../hooks/useClasses';

import './style.scss';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableGenericNodeEntity;
}

const NodeTipHighlighted: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('NodeTipHighlighted');

  const langcode = entity.getIn(['langcode', 0, 'value'], DEFAULT_LANGUAGE);
  const path = entity.getIn(['paths', langcode], '');
  const title = entity.getIn(['title', 0, 'value'], '');

  return (
    <li className={joinClasses(buildClass(), className)}>
      <CoreLink to={path} className={buildClass('link')} title={title} />
    </li>
  );
};

export default NodeTipHighlighted;
